(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9603,9789,2836,2657,6552],{

/***/ 27646:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search",
      function () {
        return __webpack_require__(33238);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 33238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25935);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2962);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var pages_404__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31788);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67294);
/* harmony import */ var react_sticky_box__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(42836);
/* harmony import */ var src_2_0_widgets_widget_breadcrumb__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36552);
/* harmony import */ var src_2_0_widgets_widget_heading__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2657);
/* harmony import */ var src_components_cards_card_h__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9789);
/* harmony import */ var src_components_cards_card_v__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(40166);
/* harmony import */ var src_components_layouts__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(75519);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(15072);
/* harmony import */ var src_services_member_auth_utils_decryption_payload__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(84233);
/* harmony import */ var src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(84920);
/* harmony import */ var src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(34892);
/* harmony import */ var src_utils_detect_scrolling__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(32668);
/* harmony import */ var src_utils_device__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(25283);
/* harmony import */ var src_utils_services__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(73113);
/* harmony import */ var src_utils_useUser__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(51148);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(186);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .fetch-data {\n    display: block;\n    text-align: center;\n    font-size: 18pt;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
























var DynamicAds = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 84920)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84920)
            ];
        }
    }
});
var PageSearch = function(param) {
    var articles = param.articles, lastNews = param.lastNews, searchText = param.searchText, nextArticles = param.nextArticles, ads = param.ads, dataAdsHeader = param.dataAdsHeader;
    var _data = (0,src_utils_useUser__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)();
    var sessionSevId = (_data === null || _data === void 0 ? void 0 : _data.user) ? (0,src_services_member_auth_utils_decryption_payload__WEBPACK_IMPORTED_MODULE_17__/* .decryptionClient */ .F)(_data === null || _data === void 0 ? void 0 : _data.user) : null;
    if (articles === null) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pages_404__WEBPACK_IMPORTED_MODULE_8__["default"], {
            dataAdsHeader: dataAdsHeader,
            sessionSevId: sessionSevId
        });
    }
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(true), adsBox = ref[0], setAdsBox = ref[1];
    var handleLightBoxClick = function() {
        setAdsBox(false);
    };
    var nextLinkRef = (0,react__WEBPACK_IMPORTED_MODULE_9__.useRef)((nextArticles === null || nextArticles === void 0 ? void 0 : nextArticles.next) || null);
    var listArticlesRef = (0,react__WEBPACK_IMPORTED_MODULE_9__.useRef)(articles);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(articles), listArticles = ref1[0], setListArticles = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(false), isFetching = ref2[0], setIsFetching = ref2[1];
    var handleScroll = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(0,src_utils_detect_scrolling__WEBPACK_IMPORTED_MODULE_25__/* .isShouldFetch */ .ie)()) return [
                            3,
                            2
                        ];
                        document.removeEventListener("scroll", handleScroll);
                        return [
                            4,
                            loadMoreArticles()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleScroll() {
            return _ref.apply(this, arguments);
        };
    }();
    var loadMoreArticles = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function() {
            var resData, ref, newLists, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            6,
                            7
                        ]);
                        if (!(nextArticles.next !== null)) return [
                            3,
                            4
                        ];
                        setIsFetching(true);
                        return [
                            4,
                            (0,src_utils_services__WEBPACK_IMPORTED_MODULE_21__/* .GET_ARTICLES */ .M)("".concat(nextLinkRef === null || nextLinkRef === void 0 ? void 0 : nextLinkRef.current), false, true)
                        ];
                    case 1:
                        resData = _state.sent();
                        if (!!lodash__WEBPACK_IMPORTED_MODULE_3___default().isEmpty(resData === null || resData === void 0 ? void 0 : resData.data)) return [
                            3,
                            4
                        ];
                        nextLinkRef.current = resData === null || resData === void 0 ? void 0 : (ref = resData.links) === null || ref === void 0 ? void 0 : ref.next;
                        newLists = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(listArticlesRef.current).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(resData === null || resData === void 0 ? void 0 : resData.data));
                        listArticlesRef.current = lodash__WEBPACK_IMPORTED_MODULE_3___default().uniqBy(newLists, "id");
                        setListArticles(listArticlesRef.current);
                        if (!(0,src_utils_detect_scrolling__WEBPACK_IMPORTED_MODULE_25__/* .isShouldFetch */ .ie)()) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            loadMoreArticles()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        document.addEventListener("scroll", handleScroll);
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            7
                        ];
                    case 5:
                        error = _state.sent();
                        console.error("==========> LOAD_MORE ERROR", error.message);
                        return [
                            3,
                            7
                        ];
                    case 6:
                        setIsFetching(false);
                        return [
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function loadMoreArticles() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(function() {
        document.addEventListener("scroll", handleScroll);
        return function() {
            return document.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_4__/* .NextSeo */ .PB, {
                noindex: true,
                nofollow: true,
                robotsProps: {
                    maxImagePreview: "large",
                    maxSnippet: -1,
                    maxVideoPreview: -1
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_6___default()), {
                children: [
                    !(0,src_utils_device__WEBPACK_IMPORTED_MODULE_20__/* .useDesktop */ .Ln)() && !lodash__WEBPACK_IMPORTED_MODULE_3___default().isEmpty(dataAdsHeader) ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(dataAdsHeader === null || dataAdsHeader === void 0 ? void 0 : dataAdsHeader.header_mobile)) : "",
                    (0,src_utils_device__WEBPACK_IMPORTED_MODULE_20__/* .useDesktop */ .Ln)() && !lodash__WEBPACK_IMPORTED_MODULE_3___default().isEmpty(dataAdsHeader) ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(dataAdsHeader === null || dataAdsHeader === void 0 ? void 0 : dataAdsHeader.header_desktop)) : "",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                        async: true,
                        type: "text/javascript",
                        src: "https://securepubads.g.doubleclick.net/tag/js/gpt.js"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                        type: "text/javascript",
                        dangerouslySetInnerHTML: {
                            __html: "var googletag = googletag || {}; window.googletag.cmd = googletag.cmd || [];"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(src_components_layouts__WEBPACK_IMPORTED_MODULE_15__["default"], {
                sessionSevId: sessionSevId,
                children: [
                    !lodash__WEBPACK_IMPORTED_MODULE_3___default().isEmpty(ads) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicAds, {
                        position: src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_18__.KEY_ADS_POSITION.LIGHTBOX,
                        data: ads,
                        handler: function() {
                            return handleLightBoxClick();
                        },
                        adsBox: adsBox
                    }),
                    !lodash__WEBPACK_IMPORTED_MODULE_3___default().isEmpty(ads) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicAds, {
                        position: src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_18__.KEY_ADS_POSITION.BILLBOARD,
                        data: ads
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionWrapper, {
                        id: "section-1",
                        className: "category-wrapper",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "container",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_2_0_widgets_widget_breadcrumb__WEBPACK_IMPORTED_MODULE_11__["default"], {
                                    article: {
                                        section: {
                                            th: "ผลการค้นหา ".concat(searchText)
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "row",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "col-lg-8 col-md-12",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h4", {
                                                    className: "text-extra",
                                                    style: {
                                                        filter: src_constants__WEBPACK_IMPORTED_MODULE_16__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0.7)" : "unset"
                                                    },
                                                    children: [
                                                        "ผลการค้นหา",
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h1", {
                                                    className: "heading-title",
                                                    style: {
                                                        filter: src_constants__WEBPACK_IMPORTED_MODULE_16__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0.7)" : "unset"
                                                    },
                                                    children: [
                                                        '"',
                                                        searchText === null || searchText === "null" ? " " : searchText,
                                                        '"'
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: "row",
                                                    style: {
                                                        filter: src_constants__WEBPACK_IMPORTED_MODULE_16__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0.7)" : "unset"
                                                    },
                                                    children: [
                                                        (articles === null || articles === void 0 ? void 0 : articles.length) < 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                            className: "col-12 no-article",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                                src: "".concat(src_constants__WEBPACK_IMPORTED_MODULE_16__/* .APP_IMG */ .T, "/no-article.png"),
                                                                alt: "no-article",
                                                                width: "100%"
                                                            })
                                                        }) : listArticles.map(function(item, index) {
                                                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                id: index + 1,
                                                                className: "col-6 col-md-4 mb-3",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_cards_card_v__WEBPACK_IMPORTED_MODULE_14__["default"], {
                                                                    data: item,
                                                                    path: item.link,
                                                                    description: false,
                                                                    badge: true,
                                                                    showPageviews: false,
                                                                    //! DATALAYER
                                                                    eventDataLayer: {
                                                                        type: src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_19__/* .DATALAYER_TYPE.TRACK_POSITION */ .$7.TRACK_POSITION,
                                                                        router: router === null || router === void 0 ? void 0 : router.pathname,
                                                                        section: "ข่าวทั้งหมด",
                                                                        position: "ใต้:โฆษณาตำแหน่ง billboard",
                                                                        data: {
                                                                            block: "1",
                                                                            title: item.title,
                                                                            heading: "ผลการค้นหา ".concat(searchText === null || searchText === "null" ? " " : searchText),
                                                                            index: index + 1
                                                                        }
                                                                    }
                                                                })
                                                            }, item.id);
                                                        }),
                                                        isFetching && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                            className: "fetch-data",
                                                            children: " Fetching more list items... "
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    id: "postartice",
                                                    className: "ads-sticky-overflow",
                                                    children: !lodash__WEBPACK_IMPORTED_MODULE_3___default().isEmpty(ads) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicAds, {
                                                        position: src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_18__.KEY_ADS_POSITION.POSTARTICLE,
                                                        data: ads
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "col-lg-4 col-md-12",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_sticky_box__WEBPACK_IMPORTED_MODULE_10__["default"], {
                                                offsetTop: 70,
                                                offsetBottom: 70,
                                                children: [
                                                    !lodash__WEBPACK_IMPORTED_MODULE_3___default().isEmpty(ads) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicAds, {
                                                        position: src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_18__.KEY_ADS_POSITION.STICKY_1,
                                                        data: ads
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        className: "widget-content",
                                                        style: {
                                                            filter: src_constants__WEBPACK_IMPORTED_MODULE_16__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0.7)" : "unset"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_2_0_widgets_widget_heading__WEBPACK_IMPORTED_MODULE_12__["default"], {
                                                                heading: "Latest News"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                className: "block-content",
                                                                children: Array.isArray(lastNews) && lastNews.length < 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                    className: "no-article",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                                        className: "--side",
                                                                        src: "".concat(src_constants__WEBPACK_IMPORTED_MODULE_16__/* .APP_IMG */ .T, "/no-article.png"),
                                                                        alt: "no-article",
                                                                        width: "100%"
                                                                    })
                                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
                                                                    className: "block-list",
                                                                    children: lastNews.slice(0, 4).map(function(item, index) {
                                                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_cards_card_h__WEBPACK_IMPORTED_MODULE_13__["default"], {
                                                                                data: item,
                                                                                large: false,
                                                                                showPageviews: false,
                                                                                //! DATALAYER
                                                                                eventDataLayer: {
                                                                                    type: src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_19__/* .DATALAYER_TYPE.TRACK_POSITION */ .$7.TRACK_POSITION,
                                                                                    router: router === null || router === void 0 ? void 0 : router.pathname,
                                                                                    section: "Latest News",
                                                                                    position: "ใต้:โฆษณาตำแหน่ง billboard",
                                                                                    data: {
                                                                                        block: "2",
                                                                                        title: item.title,
                                                                                        heading: "Latest News",
                                                                                        index: index + 1
                                                                                    }
                                                                                }
                                                                            })
                                                                        }, index);
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    !lodash__WEBPACK_IMPORTED_MODULE_3___default().isEmpty(ads) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicAds, {
                                                        position: src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_18__.KEY_ADS_POSITION.STICKY_2,
                                                        data: ads
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        id: "postartice",
                        className: "ads-sticky-overflow",
                        children: !lodash__WEBPACK_IMPORTED_MODULE_3___default().isEmpty(ads) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicAds, {
                            position: src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_18__.KEY_ADS_POSITION.POSTARTICLE,
                            data: ads
                        })
                    }),
                    !lodash__WEBPACK_IMPORTED_MODULE_3___default().isEmpty(ads) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicAds, {
                        position: src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_18__.KEY_ADS_POSITION.AD1X1,
                        data: ads
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (PageSearch);
var SectionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_27__["default"].div(_templateObject());


/***/ }),

/***/ 477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34892);





var Link = function(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, _href = _param.href, href = _href === void 0 ? "" : _href, _title = _param.title, title = _title === void 0 ? "" : _title, _target = _param.target, target = _target === void 0 ? "_self" : _target, _nofollow = _param.nofollow, nofollow = _nofollow === void 0 ? false : _nofollow, eventDataLayer = _param.eventDataLayer, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "href",
        "title",
        "target",
        "nofollow",
        "eventDataLayer",
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: className,
        title: title,
        target: target,
        href: href,
        rel: "noopener noreferrer ".concat(nofollow ? "nofollow" : ""),
        // ยิง datalayer เฉพาะตอนได้รับ eventDataLayer ที่มี type จริง
        // กันเคสการ์ดที่ไม่ได้ส่ง eventDataLayer มา (เดิม <Link> จะยิงก้อนว่างทับของจริง = "คลิกแล้วไม่ได้ค่า")
        onClick: (eventDataLayer === null || eventDataLayer === void 0 ? void 0 : eventDataLayer.type) ? function() {
            return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_1__/* .sendDataLayerGlobal */ .dE)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, eventDataLayer));
        } : undefined
    }, props), {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Link);


/***/ }),

/***/ 36552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15072);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(186);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &.breadcrumb {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    min-height: 40px;\n    li {\n      font-size: 16pt;\n      min-height: 30px;\n      &.more-cate {\n        a {\n          color: var(--primary-color);\n        }\n      }\n      color: var(--primary-color);\n    }\n    li + li {\n      &:before {\n        content: '>';\n        padding: 0 10px;\n        color: var(--primary-color);\n      }\n    }\n    @media (max-width: 767px) {\n      justify-content: center;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function WidgetBreadcrumb(param) {
    var article = param.article;
    var ref, ref1, ref2, ref3;
    // console.log('article', article);
    var categoryName = ((ref = article.section) === null || ref === void 0 ? void 0 : ref.th) === "ข่าวล่าสุด" ? "Latest News" : (ref1 = article.section) === null || ref1 === void 0 ? void 0 : ref1.th;
    var subCategoryName = article.subCategory ? article.subCategory.th : null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(WidgetWrapper, {
        className: "breadcrumb",
        style: {
            filter: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0.7)" : ""
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                    href: "/",
                    children: "หน้าแรก"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                className: "more-cate",
                children: [
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                        href: "".concat(categoryName ? "/category/".concat(article === null || article === void 0 ? void 0 : (ref2 = article.section) === null || ref2 === void 0 ? void 0 : ref2.en) : ""),
                        children: categoryName
                    })
                ]
            }),
            subCategoryName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                className: "more-cate",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                        href: "".concat("/category/".concat(article === null || article === void 0 ? void 0 : (ref3 = article.section) === null || ref3 === void 0 ? void 0 : ref3.en, "/").concat(article.subCategory.en)),
                        children: subCategoryName
                    }),
                    " "
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (WidgetBreadcrumb);
var WidgetWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].ul(_templateObject());


/***/ }),

/***/ 2657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ WidgetHeading; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2777);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15072);
/* harmony import */ var src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34892);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(186);
/* harmony import */ var _link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(477);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  align-items: baseline;\n  border-bottom: 3px solid var(--primary-color);\n\n  h2 {\n    background: var(--white-color);\n    color: var(--text-color);\n    width: fit-content;\n    font-family: 'DBHelvethaicaXBd', sans-serif;\n    padding: 5px 15px 5px 0px;\n    border-radius: 10px 10px 0 0px;\n    font-size: 28pt;\n    font-weight: 400;\n    margin-bottom: -13px;\n    letter-spacing: 0px;\n    text-transform: uppercase;\n\n    @media (max-width: 768px) {\n      font-size: 24pt;\n    }\n    // @media (max-width: 768px) {\n    //   font-family: 'DBHelvethaicaXBd', sans-serif;\n    //   font-weight: 500;\n    // }\n    span {\n      color: #f10300;\n    }\n  }\n  a h2 {\n    cursor: pointer;\n    transition: all 0.5s ease-out;\n    :hover {\n      transform: scale(1.05);\n    }\n  }\n  .text-read {\n    color: var(--primary-color);\n    cursor: pointer;\n    font-size: 12pt;\n    font-weight: 500;\n    background: var(--white-color);\n    margin-bottom: -10px;\n    padding-left: 10px;\n\n    /* padding-bottom: 8px; */\n    svg {\n      color: var(--primary-color);\n      margin-left: -3px;\n    }\n    &:hover {\n      svg {\n        color: var(--hover-color);\n      }\n      color: var(--hover-color);\n    }\n  }\n\n  .heading {\n    &.--hover {\n      &:hover {\n        color: #0600e7;\n      }\n    }\n    &.--live {\n      font-size: 24pt;\n    }\n  }\n\n  .live-button {\n    svg {\n      margin-right: 7px;\n      margin-bottom: 4px;\n    }\n    svg path {\n      fill: red;\n      /* Copy this @keyframes block to your CSS*/\n      @keyframes signalanimate {\n        0% {\n          opacity: 0;\n        }\n        50% {\n          opacity: 1;\n        }\n        100% {\n          opacity: 0;\n        }\n      }\n      &:nth-of-type(1) {\n        -webkit-animation: signalanimate 2s infinite;\n        animation: signalanimate 2s infinite;\n      }\n      &:nth-of-type(2) {\n        -webkit-animation: signalanimate 2s infinite;\n        animation: signalanimate 2s infinite;\n        -webkit-animation-delay: 0.5s;\n        animation-delay: 0.5s;\n      }\n      &:nth-of-type(3) {\n        -webkit-animation: signalanimate 2s infinite;\n        animation: signalanimate 2s infinite;\n        -webkit-animation-delay: 1s;\n        animation-delay: 1s;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







function WidgetHeading(param) {
    var _heading = param.heading, heading = _heading === void 0 ? "" : _heading, customHeading = param.customHeading, _className = param.className, className = _className === void 0 ? "" : _className, _eventDataLayer = param.eventDataLayer, eventDataLayer = _eventDataLayer === void 0 ? {} : _eventDataLayer, _showReadmore = param.showReadmore, showReadmore = _showReadmore === void 0 ? false : _showReadmore, _link = param.link, link = _link === void 0 ? "" : _link, _isSectionLive = param.isSectionLive, isSectionLive = _isSectionLive === void 0 ? false : _isSectionLive;
    if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default()(heading)) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(WidgetWrapper, {
        className: "widget-heading ".concat(className),
        style: {
            filter: src_constants__WEBPACK_IMPORTED_MODULE_3__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0.7)" : ""
        },
        children: [
            isSectionLive ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h2", {
                className: "heading --live",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                        className: "live-button",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                                x: "0px",
                                y: "0px",
                                width: "17px",
                                height: "15.8px",
                                viewBox: "0 0 17 15.8",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                        d: "M8.5,6.8c-0.9,0-1.7,0.8-1.7,1.7c0,0.9,0.8,1.7,1.7,1.7c0.9,0,1.7-0.8,1.7-1.7C10.2,7.6,9.5,6.8,8.5,6.8z"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                        d: "M13.6,8.5c0-2.8-2.2-5.1-5-5.2c-2.8,0-5.1,2.2-5.2,5c0,0,0,0.1,0,0.1c0,1.8,1,3.5,2.6,4.4l0.9-1.4c-1.6-1-2.1-3-1.2-4.6s3-2.1,4.6-1.2c1,0.6,1.7,1.7,1.7,2.9c0,1.2-0.6,2.3-1.7,2.9l0.9,1.4C12.7,12,13.6,10.3,13.6,8.5L13.6,8.5z"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                        d: "M8.5,0C3.8,0,0,3.8,0,8.5c0,3,1.6,5.8,4.3,7.3l0.9-1.4c-3.3-1.9-4.4-6.1-2.5-9.3s6.1-4.4,9.3-2.5c2.1,1.2,3.4,3.5,3.4,5.9c0,2.4-1.3,4.7-3.4,5.9l0.9,1.4c4.1-2.3,5.5-7.5,3.1-11.6C14.4,1.6,11.6,0,8.5,0z"
                                    })
                                ]
                            }),
                            "LIVE"
                        ]
                    }),
                    " ",
                    "เกาะติดเลือกตั้ง"
                ]
            }) : link ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                href: link,
                onClick: function() {
                    return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_4__/* .sendDataLayerGlobal */ .dE)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, eventDataLayer));
                },
                children: customHeading !== null && customHeading !== void 0 ? customHeading : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                    className: "heading ".concat(link ? "--hover" : ""),
                    children: heading
                })
            }) : customHeading !== null && customHeading !== void 0 ? customHeading : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                className: "heading ".concat(link ? "--hover" : ""),
                children: heading
            }),
            showReadmore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                href: link,
                onClick: function() {
                    return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_4__/* .sendDataLayerGlobal */ .dE)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, eventDataLayer));
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                    className: "text-read",
                    children: [
                        "ดูทั้งหมด ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_7__.FiArrowRightCircle, {})
                    ]
                })
            })
        ]
    });
};
var WidgetWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div(_templateObject());


/***/ }),

/***/ 9789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_locale_th__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62019);
/* harmony import */ var dayjs_locale_th__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_th__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_plugin_buddhistEra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40683);
/* harmony import */ var dayjs_plugin_buddhistEra__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_buddhistEra__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(87771);
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7696);
/* harmony import */ var src_components_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84334);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15072);
/* harmony import */ var src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34892);
/* harmony import */ var src_utils_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(39334);
/* harmony import */ var src_utils_increment_countview__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(20464);














dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_buddhistEra__WEBPACK_IMPORTED_MODULE_3___default()));
var CardH = function(param) {
    var data = param.data, _large = param.large, large = _large === void 0 ? false : _large, _description = param.description, description = _description === void 0 ? false : _description, _withMB = param.withMB, withMB = _withMB === void 0 ? null : _withMB, _txtStyle = param.txtStyle, txtStyle = _txtStyle === void 0 ? false : _txtStyle, _external = param.external, external = _external === void 0 ? false : _external, _eyeBall = param.eyeBall, eyeBall = _eyeBall === void 0 ? true : _eyeBall, eventDataLayer = param.eventDataLayer, heading = param.heading, _showFooter = param.showFooter, showFooter = _showFooter === void 0 ? true : _showFooter, _isVideo = param.isVideo, isVideo = _isVideo === void 0 ? false : _isVideo, _showReadmore = param.showReadmore, showReadmore = _showReadmore === void 0 ? false : _showReadmore, _isH3 = param.isH3, isH3 = _isH3 === void 0 ? true : _isH3, _showBlurb = param.showBlurb, showBlurb = _showBlurb === void 0 ? false : _showBlurb, _showBadge = param.showBadge, showBadge = _showBadge === void 0 ? false : _showBadge, _loading = param.loading, loading = _loading === void 0 ? "lazy" : _loading;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(0), countView = ref4[0], setCountView = ref4[1];
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        (0,src_utils_increment_countview__WEBPACK_IMPORTED_MODULE_10__/* .incrementCountview */ .x)(data).then(function(item) {
            return setCountView(item);
        }).catch(function() {
            return setCountView(0);
        });
    }, []);
    var categoryNameTH = (data === null || data === void 0 ? void 0 : (ref = data.subCategory) === null || ref === void 0 ? void 0 : ref.th) ? data === null || data === void 0 ? void 0 : (ref1 = data.subCategory) === null || ref1 === void 0 ? void 0 : ref1.th : data === null || data === void 0 ? void 0 : (ref2 = data.section) === null || ref2 === void 0 ? void 0 : ref2.th;
    var dateUpdate = dayjs__WEBPACK_IMPORTED_MODULE_1___default()(data === null || data === void 0 ? void 0 : data.published_at).locale("th").format("DD MMM BBBB | H:mm");
    var conditionBadge = showBadge && (0,src_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .convertBadge */ .lC)(data, false);
    // console.log(data);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: external ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: data === null || data === void 0 ? void 0 : data.link,
            //! DATALAYER
            target: "_blank",
            rel: "noopener noreferrer",
            className: "card-wrapper",
            onClick: function() {
                return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_8__/* .sendDataLayerGlobal */ .dE)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, eventDataLayer));
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "card-h ".concat(withMB === null ? "" : withMB),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "card-h-thumb ".concat(large ? "--large" : ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_image__WEBPACK_IMPORTED_MODULE_6__["default"], {
                                image: data === null || data === void 0 ? void 0 : data.image,
                                title: data === null || data === void 0 ? void 0 : data.title,
                                external: external,
                                type: large ? "CARD_MEDIUM" : "CARD_SMALL",
                                loading: loading
                            }),
                            isVideo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "icon",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_12__/* .RiPlayCircleLine */ .YEk, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "card-h-content ".concat(large ? "--large" : ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "card-h-content-title ".concat(txtStyle ? "--light" : "", " text-excerpt-2"),
                                children: data === null || data === void 0 ? void 0 : data.title
                            }),
                            showReadmore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "read-more",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "อ่านต่อ..."
                                })
                            }),
                            showFooter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "card-h-content-meta ".concat(txtStyle ? "--small" : ""),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_13__/* .AiOutlineClockCircle */ .cjn, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: dateUpdate
                                    })
                                ]
                            }),
                            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-excerpt-3",
                                children: data === null || data === void 0 ? void 0 : data.blurb
                            })
                        ]
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: data === null || data === void 0 ? void 0 : data.link,
            className: "card-wrapper",
            //! DATALAYER
            onClick: function() {
                return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_8__/* .sendDataLayerGlobal */ .dE)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, eventDataLayer));
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "card-h ".concat(withMB === null ? "" : withMB),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "card-h-thumb ".concat(large ? "--large" : ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_image__WEBPACK_IMPORTED_MODULE_6__["default"], {
                                image: data === null || data === void 0 ? void 0 : data.image,
                                title: data === null || data === void 0 ? void 0 : data.title,
                                type: large ? "CARD_MEDIUM" : "CARD_SMALL",
                                loading: loading
                            }),
                            (data === null || data === void 0 ? void 0 : (ref3 = data.section) === null || ref3 === void 0 ? void 0 : ref3.th) !== null && large && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "badge",
                                children: categoryNameTH
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "card-h-content ".concat(large ? "--large" : ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "card-h-content-title ".concat(txtStyle ? "--light" : "", " text-excerpt-2"),
                                children: data === null || data === void 0 ? void 0 : data.title
                            }),
                            showBlurb && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "card-h-content-blurb ".concat(txtStyle ? "--light" : "", " text-excerpt-2"),
                                children: data === null || data === void 0 ? void 0 : data.blurb
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "card-h-content-meta ".concat(txtStyle ? "--small" : ""),
                                children: [
                                    conditionBadge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "meta-badge",
                                        children: conditionBadge
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_13__/* .AiOutlineClockCircle */ .cjn, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "date",
                                        children: dateUpdate
                                    }),
                                    eyeBall && countView > 0 && countView > Number(src_constants__WEBPACK_IMPORTED_MODULE_7__/* .NEXT_PUBLIC_DEFAULT_COUNT_VIEW */ .d$) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "pageview",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_13__/* .AiOutlineEye */ .Zju, {}),
                                            countView > 999 ? numeral__WEBPACK_IMPORTED_MODULE_4___default()(countView).format("0.0a") : countView
                                        ]
                                    })
                                ]
                            }),
                            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-excerpt-3",
                                children: data === null || data === void 0 ? void 0 : data.blurb
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (CardH);


/***/ }),

/***/ 84920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ads": function() { return /* binding */ Ads; },
/* harmony export */   "KEY_ADS_PAGE": function() { return /* binding */ KEY_ADS_PAGE; },
/* harmony export */   "KEY_ADS_POSITION": function() { return /* binding */ KEY_ADS_POSITION; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15072);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(186);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  z-index: 2147483647;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #4142429c;\n\n  &.close {\n    display: none;\n  }\n  .light-box {\n    position: relative;\n    &::before {\n      content: 'X';\n      cursor: pointer;\n      position: absolute;\n      top: -24px;\n      right: 0;\n      color: rgba(0, 0, 0, 0.788);\n      background-color: #fafafab7;\n      border-top-right-radius: 3px;\n      border-top-left-radius: 3px;\n      padding: 2px 7px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &.ads-billboard {\n    position: relative;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgb(245, 245, 245);\n    /* margin: 30px auto; */\n    min-height: 300px;\n    iframe {\n      margin: auto;\n    }\n    @media (max-width: 475px) {\n      min-height: 330px;\n    }\n  }\n  &.ads-ad1x1 {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n  }\n  &.ads-sticky-1,\n  &.ads-sticky-2,\n  &.ads-sticky-3 {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n    margin-bottom: 15px;\n    min-height: 300px;\n    background: rgb(245, 245, 245);\n    padding: 15px;\n  }\n  &.ads-postarticle {\n    position: sticky;\n    bottom: 0;\n    z-index: 50;\n    display: flex;\n    justify-content: center;\n    overflow: hidden;\n    min-height: 90px;\n  }\n\n  &.ads-inarticle-1,\n  &.ads-inarticle-2,\n  &.ads-inarticle-3 {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    max-width: 100%;\n    height: auto;\n    margin: 5px auto;\n    overflow: hidden;\n    min-height: 90px;\n    background: rgb(245, 245, 245);\n    padding: 15px 0px;\n    img,\n    iframe {\n      max-width: 100%;\n      display: block;\n      margin: auto;\n    }\n  }\n  &.ads-election-1,\n  &.ads-election-2,\n  &.ads-election-3,\n  &.ads-election-4,\n  &.ads-election-5,\n  &.ads-election-6,\n  &.ads-election-7 {\n    margin: 15px 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .mobile {\n    display: none;\n    @media (max-width: 1024px) {\n      display: block;\n    }\n  }\n  .desktop {\n    display: block;\n    @media (max-width: 1025px) {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






// ? TODO:  <DynamicAds position={KEY_ADS_POSITION.BILLBOARD} page={KEY_ADS_PAGE.CONTENT} />
/* -------------------------------- KEY_TYPE -------------------------------- */ var KEY_ADS_POSITION = {
    BILLBOARD: "billboard",
    STICKY_1: "sticky-1",
    STICKY_2: "sticky-2",
    STICKY_3: "sticky-3",
    INARTICLE_1: "inarticle-1",
    INARTICLE_2: "inarticle-2",
    INARTICLE_3: "inarticle-3",
    POSTARTICLE: "postarticle",
    AD1X1: "ad1x1",
    LIGHTBOX: "light-box",
    ELECTION_1: "election-1",
    ELECTION_2: "election-2",
    ELECTION_3: "election-3",
    ELECTION_4: "election-4",
    ELECTION_5: "election-5",
    ELECTION_6: "election-6",
    ELECTION_7: "election-7",
    RECTANGLE_A: "rectangle-a",
    RECTANGLE_B: "rectangle-b",
    RECTANGLE_C: "rectangle-c"
};
var KEY_ADS_PAGE = {
    HOMEPAGE: "homepage",
    CATEGORY: "category",
    CONTENT: "content",
    TAG: "tag",
    SEARCH: "search"
};
var Ads = function(param) {
    var _adsBox = param.adsBox, adsBox = _adsBox === void 0 ? false : _adsBox, _slotId = param.slotId, slotId = _slotId === void 0 ? "" : _slotId, _slotSize = param.slotSize, slotSize = _slotSize === void 0 ? [] : _slotSize, _slotDefine = param.slotDefine, slotDefine = _slotDefine === void 0 ? "" : _slotDefine, _className = param.className, className = _className === void 0 ? "" : _className, position = param.position, _handler = param.handler, handler = _handler === void 0 ? function() {} : _handler;
    if (lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(slotId) || lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(slotDefine) || lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(slotSize)) return null;
    // const isDesktop = useDesktop();
    // const slotSize = isDesktop ? sizeDesktop : !_.isEmpty(sizeMobile) && sizeMobile;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        window.googletag.cmd.push(function() {
            window.googletag.defineSlot(slotDefine, slotSize, slotId).addService(window.googletag.pubads()).setCollapseEmptyDiv(true, true);
            window.googletag.pubads().enableSingleRequest();
            window.googletag.enableServices();
            window.googletag.cmd.push(function() {
                window.googletag.display(slotId);
            });
        });
    }, []);
    // console.log('position', position);
    // console.log('slotId', slotId);
    switch(position){
        case "light-box":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AdsLightBox, {
                    id: "ads-nlightbox",
                    className: "light-box-ads ".concat(!adsBox ? "close" : "open"),
                    style: {
                        filter: src_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0)" : ""
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "light-box",
                        onClick: handler,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AdsWrapper, {
                            className: className,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                id: slotId
                            })
                        })
                    })
                })
            });
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AdsWrapper, {
                className: className,
                style: {
                    filter: src_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0)" : "unset"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    id: slotId
                })
            });
    }
};
var AdsLightBox = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject());
var AdsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject1());
var DynamicAds = function(param) {
    var _adsBox = param.adsBox, adsBox = _adsBox === void 0 ? false : _adsBox, _position = param.position, position = _position === void 0 ? "" : _position, _data = param.data, data = _data === void 0 ? [] : _data, _handler = param.handler, handler = _handler === void 0 ? function() {} : _handler;
    var isMb = (0,react_responsive__WEBPACK_IMPORTED_MODULE_6__.useMediaQuery)({
        query: "(max-width: 1023px)"
    });
    var isDt = (0,react_responsive__WEBPACK_IMPORTED_MODULE_6__.useMediaQuery)({
        query: "(min-width: 1024px)"
    });
    var _adsArray = !lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(data) ? data : [];
    // เช็คตำแหน่ง ADS
    var _adsSlot = _adsArray.find(function(_data) {
        return (_data === null || _data === void 0 ? void 0 : _data.position) === position;
    });
    if (position === KEY_ADS_POSITION.POSTARTICLE) {
        // console.log(position, `ads-${position}`);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SlotWrapper, {
            className: "ads-sticky-overflow",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "mobile",
                    children: !isDt && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Ads, {
                        adsBox: adsBox,
                        handler: handler,
                        className: "ads-".concat(position),
                        slotDefine: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.slotDefine,
                        slotId: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.slotId,
                        slotSize: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.sizeMobile,
                        position: position
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "desktop",
                    children: !isMb && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Ads, {
                        adsBox: adsBox,
                        handler: handler,
                        className: "ads-".concat(position),
                        slotDefine: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.slotDefine,
                        slotId: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.slotId,
                        slotSize: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.sizeDesktop,
                        position: position
                    })
                })
            ]
        });
    }
    if (!lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(_adsSlot)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SlotWrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "mobile",
                    children: !isDt && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Ads, {
                        adsBox: adsBox,
                        handler: handler,
                        className: "ads-".concat(position),
                        slotDefine: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.slotDefine,
                        slotId: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.slotId,
                        slotSize: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.sizeMobile,
                        position: position
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "desktop",
                    children: !isMb && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Ads, {
                        adsBox: adsBox,
                        handler: handler,
                        className: "ads-".concat(position),
                        slotDefine: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.slotDefine,
                        slotId: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.slotId,
                        slotSize: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.sizeDesktop,
                        position: position
                    })
                })
            ]
        });
    }
    return null;
};
/* harmony default export */ __webpack_exports__["default"] = (DynamicAds);
// :: Default ::
// <Ads
//    className='ads'
//    slotDefine='/231599934,12270527/springnews/homepage/billboard'
//    slotId='div-gpt-ad-1622722566999-0'
//    slotSize=[[300, 250], [336, 280]] />
var SlotWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject2());


/***/ }),

/***/ 32668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ie": function() { return /* binding */ isShouldFetch; }
/* harmony export */ });
/* unused harmony exports getScrollElement, isSectionOne, isShouldFetchReadmore, calculateReadTime */

var getScrollElement = function(el) {
    var newEl = el;
    var elTop = newEl.offsetTop - newEl.offsetHeight * 3;
    while(newEl.offsetParent){
        newEl = newEl.offsetParent;
        elTop += newEl.offsetTop;
    }
    return elTop;
};
var isShouldFetch = function() {
    var footerEl = document.querySelector(".footer-wrapper");
    if (footerEl) {
        var scrollElement = getScrollElement(footerEl);
        return document.documentElement.scrollTop > scrollElement;
    }
    return false;
};
var isSectionOne = function() {
    var sectionEl = document.getElementById("section-1");
    if (sectionEl) {
        return true;
    }
    return false;
};
var isShouldFetchReadmore = function() {
    var footerEl = document.querySelector(".loadmore");
    if (footerEl) {
        var scrollElement = getScrollElement(footerEl);
        return document.documentElement.scrollTop + 700 > scrollElement;
    }
    return false;
};
function calculateReadTime(counter) {
    var toArray = function(num) {
        return num && _to_consumable_array("".concat(num)).map(function(elem) {
            return +elem;
        });
    };
    var _a = toArray(counter)[toArray(counter).length - 1] === 0 ? 0 : 1;
    var _b = counter - 1;
    var start = Math.floor((_a === 0 ? _b : counter) / 10) * 10;
    var end = Math.ceil(counter / 10) * 10;
    var first = start === 0 ? 1 : start + 1;
    var second = end === 0 ? 10 : end;
    return "".concat(first, "-").concat(second);
}


/***/ }),

/***/ 73113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ GET; },
/* harmony export */   "M": function() { return /* binding */ GET_ARTICLES; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15072);
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39334);






// Service : GET ------------------------- */
function GET() {
    return _GET.apply(this, arguments);
}
function _GET() {
    _GET = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var url, external, all, _url, response, _tmp, data, _tmp1, err;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "", external = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false, all = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    _url = external ? "".concat(url) : "".concat(src_constants__WEBPACK_IMPORTED_MODULE_1__/* .API_URI */ .G9).concat(url);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    _tmp = {};
                    return [
                        4,
                        fetch(_url, (_tmp.method = "GET", _tmp.headers = {
                            "Content-Type": "text/plain" // Solved issues call OPTIONS
                        }, _tmp))
                    ];
                case 2:
                    response = _state.sent();
                    if (!response.ok) {
                        throw new TypeError("Network response was not OK");
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    data = _state.sent();
                    _tmp1 = {};
                    // If don't have data return [];
                    // If have data return [{ id: 1 }] or { data: [] }
                    // If can't call api return { data: null, msg: null }
                    // console.log(timestamp(), _url, ':');
                    if (!data.msg) {
                        if (!lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(data.data)) {
                            return [
                                2,
                                all ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_tmp1, data) : data.data
                            ];
                        }
                        return [
                            2,
                            data
                        ];
                    }
                    return [
                        2,
                        []
                    ];
                case 4:
                    err = _state.sent();
                    console.log("".concat((0,_helper__WEBPACK_IMPORTED_MODULE_2__/* .timestamp */ .AB)(), " ===========> GET ERROR : ").concat(_url));
                    console.log("".concat(err));
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return _GET.apply(this, arguments);
}
function GET_ARTICLES() {
    return _GET_ARTICLES.apply(this, arguments);
}
function _GET_ARTICLES() {
    _GET_ARTICLES = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var url, external, all, _url, response, _tmp, data, _tmp1, _tmp2, err;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "", external = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false, all = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    _url = external ? "".concat(url) : "".concat(src_constants__WEBPACK_IMPORTED_MODULE_1__/* .API_URI */ .G9).concat(url);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    _tmp = {};
                    return [
                        4,
                        fetch(_url, (_tmp.method = "GET", _tmp.headers = {
                            "Content-Type": "text/plain" // Solved issues call OPTIONS
                        }, _tmp))
                    ];
                case 2:
                    response = _state.sent();
                    if (!response.ok) {
                        throw new TypeError("Network response was not OK");
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    data = _state.sent();
                    _tmp1 = {};
                    if ((data === null || data === void 0 ? void 0 : data.statusCode) === 404) {
                        return [
                            2,
                            data
                        ];
                    } else if (!lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(data === null || data === void 0 ? void 0 : data.data)) {
                        return [
                            2,
                            all ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_tmp1, data) : data === null || data === void 0 ? void 0 : data.data
                        ];
                    }
                    _tmp2 = {};
                    return [
                        2,
                        all ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_tmp2, data) : []
                    ];
                case 4:
                    err = _state.sent();
                    console.log("".concat(new Date().toUTCString(), " ===========> GET ERROR : ").concat(_url));
                    console.log("".concat(err));
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return _GET_ARTICLES.apply(this, arguments);
}


/***/ }),

/***/ 51148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31955);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15072);
/* eslint-disable no-unused-vars */ 





function useUser() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}), result = ref[0], setResult = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), error = ref2[0], setError = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var isLogin = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("login-state");
        var cookies = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("login-data");
        var getUser = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                var response, _tmp, _tmp1, res, _tmp2, _tmp3, error;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                5,
                                6,
                                7
                            ]);
                            _tmp = {};
                            return [
                                4,
                                fetch("/api/auth/me", (_tmp.method = "GET", _tmp.headers = {
                                    "Content-Type": "application/json"
                                }, _tmp))
                            ];
                        case 1:
                            response = _state.sent();
                            if (!(!response.ok || response.status === 204 || response.statusText === "No Content")) return [
                                3,
                                2
                            ];
                            js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove("login-state");
                            _tmp1 = {};
                            setResult(_tmp1);
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                response.json()
                            ];
                        case 3:
                            res = _state.sent();
                            _tmp2 = {};
                            js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set("login-data", res, (_tmp2.secure = true, _tmp2.expires = Number(src_constants__WEBPACK_IMPORTED_MODULE_3__/* .NEXT_PUBLIC_LOGIN_COOKIE_DATE */ .B6), _tmp2)); //, { expires: 1, sameSite: 'strict', secure: true, httpOnly: true }
                            _tmp3 = {};
                            setResult((_tmp3.user = res, _tmp3));
                            _state.label = 4;
                        case 4:
                            return [
                                3,
                                7
                            ];
                        case 5:
                            error = _state.sent();
                            setError(error);
                            return [
                                3,
                                7
                            ];
                        case 6:
                            setLoading(false);
                            return [
                                7
                            ];
                        case 7:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getUser() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!lodash__WEBPACK_IMPORTED_MODULE_1___default().isEmpty(isLogin) && !lodash__WEBPACK_IMPORTED_MODULE_1___default().isEmpty(cookies)) {
            var cook = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("login-data");
            setResult({
                user: cook
            });
        } else if (!lodash__WEBPACK_IMPORTED_MODULE_1___default().isEmpty(isLogin) && lodash__WEBPACK_IMPORTED_MODULE_1___default().isEmpty(cookies)) {
            getUser();
        }
    }, []);
    return result;
}
/* harmony default export */ __webpack_exports__["Z"] = (useUser);


/***/ }),

/***/ 42836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ StickyBox; }
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(91033);
;// CONCATENATED MODULE: ./node_modules/react-sticky-box/dist/es/index.js





var getScrollParent = function (node) {
  var parent = node;

  while (parent = parent.parentElement) {
    var overflowYVal = getComputedStyle(parent, null).getPropertyValue("overflow-y");
    if (parent === document.body) return window;
    if (overflowYVal === "auto" || overflowYVal === "scroll") return parent;
  }

  return window;
};

var offsetTill = function (node, target) {
  var current = node;
  var offset = 0; // If target is not an offsetParent itself, subtract its offsetTop and set correct target

  if (target.firstChild && target.firstChild.offsetParent !== target) {
    offset += node.offsetTop - target.offsetTop;
    target = node.offsetParent;
    offset += -node.offsetTop;
  }

  do {
    offset += current.offsetTop;
    current = current.offsetParent;
  } while (current && current !== target);

  return offset;
};

var stickyProp = null;

if (typeof CSS !== "undefined" && CSS.supports) {
  if (CSS.supports("position", "sticky")) stickyProp = "sticky";else if (CSS.supports("position", "-webkit-sticky")) stickyProp = "-webkit-sticky";
} // Inspired by https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection


var passiveArg = false;

try {
  var opts = Object.defineProperty({}, "passive", {
    // eslint-disable-next-line getter-return
    get: function get() {
      passiveArg = {
        passive: true
      };
    }
  });
  window.addEventListener("testPassive", null, opts);
  window.removeEventListener("testPassive", null, opts);
} catch (e) {}

var StickyBox =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(StickyBox, _React$Component);

  function StickyBox(props) {
    var _this = _React$Component.call(this, props) || this;

    _this.addListener = function (element, event, handler, passive) {
      element.addEventListener(event, handler, passive);

      _this.unsubscribes.push(function () {
        return element.removeEventListener(event, handler);
      });
    };

    _this.addResizeObserver = function (node, handler) {
      var ro = new ResizeObserver_es["default"](handler);
      ro.observe(node);

      _this.unsubscribes.push(function () {
        return ro.disconnect();
      });
    };

    _this.registerContainerRef = function (n) {
      if (!stickyProp) return;
      _this.node = n;

      if (n) {
        _this.scrollPane = getScrollParent(_this.node);
        _this.latestScrollY = _this.scrollPane === window ? window.scrollY : _this.scrollPane.scrollTop;

        _this.addListener(_this.scrollPane, "scroll", _this.handleScroll, passiveArg);

        _this.addListener(_this.scrollPane, "mousewheel", _this.handleScroll, passiveArg);

        if (_this.scrollPane === window) {
          _this.addListener(window, "resize", _this.handleWindowResize);

          _this.handleWindowResize();
        } else {
          _this.addResizeObserver(_this.scrollPane, _this.handleScrollPaneResize);

          _this.handleScrollPaneResize();
        }

        _this.addResizeObserver(_this.node.parentNode, _this.handleParentNodeResize);

        _this.handleParentNodeResize();

        _this.addResizeObserver(_this.node, _this.handleNodeResize);

        _this.handleNodeResize({
          initial: true
        });

        _this.initial();
      } else {
        _this.unsubscribes.forEach(function (fn) {
          return fn();
        });

        _this.unsubscribes = [];
        _this.scrollPane = null;
      }
    };

    _this.getCurrentOffset = function () {
      if (_this.mode === "relative") return _this.offset;
      var _this$props = _this.props,
          offsetTop = _this$props.offsetTop,
          offsetBottom = _this$props.offsetBottom;

      if (_this.mode === "stickyTop") {
        return Math.max(0, _this.scrollPaneOffset + _this.latestScrollY - _this.naturalTop + offsetTop);
      }

      if (_this.mode === "stickyBottom") {
        return Math.max(0, _this.scrollPaneOffset + _this.latestScrollY + _this.viewPortHeight - (_this.naturalTop + _this.nodeHeight + offsetBottom));
      }
    };

    _this.handleWindowResize = function () {
      _this.viewPortHeight = window.innerHeight;
      _this.scrollPaneOffset = 0;

      _this.handleScroll();
    };

    _this.handleScrollPaneResize = function () {
      _this.viewPortHeight = _this.scrollPane.offsetHeight;

      if (false) {} // Only applicable if scrollPane is an offsetParent


      if (_this.scrollPane.firstChild.offsetParent === _this.scrollPane) {
        _this.scrollPaneOffset = _this.scrollPane.getBoundingClientRect().top;
      } else {
        _this.scrollPaneOffset = 0;
      }

      _this.handleScroll();
    };

    _this.handleParentNodeResize = function () {
      var parentNode = _this.node.parentNode;
      var computedParentStyle = getComputedStyle(parentNode, null);
      var parentPaddingTop = parseInt(computedParentStyle.getPropertyValue("padding-top"), 10);
      var parentPaddingBottom = parseInt(computedParentStyle.getPropertyValue("padding-bottom"), 10);
      _this.naturalTop = offsetTill(parentNode, _this.scrollPane) + parentPaddingTop + _this.scrollPaneOffset;
      var oldParentHeight = _this.parentHeight;
      _this.parentHeight = parentNode.getBoundingClientRect().height - (parentPaddingTop + parentPaddingBottom);

      if (_this.mode === "relative") {
        if (_this.props.bottom) {
          _this.changeMode("relative");
        } else {
          // If parent height decreased...
          if (oldParentHeight > _this.parentHeight) {
            _this.changeToStickyBottomIfBoxTooLow(_this.latestScrollY);
          }
        }
      }

      if (oldParentHeight !== _this.parentHeight && _this.mode === "relative") {
        _this.latestScrollY = Number.POSITIVE_INFINITY;

        _this.handleScroll();
      }
    };

    _this.handleNodeResize = function (_temp) {
      var _ref = _temp === void 0 ? {} : _temp,
          initial = _ref.initial;

      var prevHeight = _this.nodeHeight;
      _this.nodeHeight = _this.node.getBoundingClientRect().height;

      if (!initial && prevHeight !== _this.nodeHeight) {
        var _this$props2 = _this.props,
            offsetTop = _this$props2.offsetTop,
            offsetBottom = _this$props2.offsetBottom,
            bottom = _this$props2.bottom;

        if (_this.nodeHeight + offsetTop + offsetBottom <= _this.viewPortHeight) {
          // Just make it sticky if node smaller than viewport
          _this.mode = undefined;

          _this.initial();
        } else {
          var diff = prevHeight - _this.nodeHeight;
          var lowestPossible = _this.parentHeight - _this.nodeHeight;
          var nextOffset = Math.min(lowestPossible, _this.getCurrentOffset() + (bottom ? diff : 0));
          _this.offset = Math.max(0, nextOffset);
          if (!bottom || _this.mode !== "stickyBottom") _this.changeMode("relative");
        }
      }
    };

    _this.handleScroll = function () {
      var _this$props3 = _this.props,
          offsetTop = _this$props3.offsetTop,
          offsetBottom = _this$props3.offsetBottom;
      var scrollY = _this.scrollPane === window ? window.scrollY : _this.scrollPane.scrollTop;
      if (scrollY === _this.latestScrollY) return;

      if (_this.nodeHeight + offsetTop + offsetBottom <= _this.viewPortHeight) {
        // Just make it sticky if node smaller than viewport
        _this.initial();

        _this.latestScrollY = scrollY;
        return;
      }

      var scrollDelta = scrollY - _this.latestScrollY;
      _this.offset = _this.getCurrentOffset();

      if (scrollDelta > 0) {
        // scroll down
        if (_this.mode === "stickyTop") {
          if (scrollY + _this.scrollPaneOffset + offsetTop > _this.naturalTop) {
            if (scrollY + _this.scrollPaneOffset + _this.viewPortHeight <= _this.naturalTop + _this.nodeHeight + _this.offset + offsetBottom) {
              _this.changeMode("relative");
            } else {
              _this.changeMode("stickyBottom");
            }
          }
        } else if (_this.mode === "relative") {
          _this.changeToStickyBottomIfBoxTooLow(scrollY);
        }
      } else {
        // scroll up
        if (_this.mode === "stickyBottom") {
          if (_this.scrollPaneOffset + scrollY + _this.viewPortHeight < _this.naturalTop + _this.parentHeight + offsetBottom) {
            if (_this.scrollPaneOffset + scrollY + offsetTop >= _this.naturalTop + _this.offset) {
              _this.changeMode("relative");
            } else {
              _this.changeMode("stickyTop");
            }
          }
        } else if (_this.mode === "relative") {
          if (_this.scrollPaneOffset + scrollY + offsetTop < _this.naturalTop + _this.offset) {
            _this.changeMode("stickyTop");
          }
        }
      }

      _this.latestScrollY = scrollY;
    };

    if (props.offset && "production" !== "production") {}

    _this.unsubscribes = [];
    return _this;
  }

  var _proto = StickyBox.prototype;

  _proto.changeMode = function changeMode(newMode) {
    var _this$props4 = this.props,
        onChangeMode = _this$props4.onChangeMode,
        offsetTop = _this$props4.offsetTop,
        offsetBottom = _this$props4.offsetBottom,
        bottom = _this$props4.bottom;
    if (this.mode !== newMode) onChangeMode(this.mode, newMode);
    this.mode = newMode;

    if (newMode === "relative") {
      this.node.style.position = "relative";

      if (bottom) {
        var nextBottom = Math.max(0, this.parentHeight - this.nodeHeight - this.offset);
        this.node.style.bottom = nextBottom + "px";
      } else {
        this.node.style.top = this.offset + "px";
      }
    } else {
      this.node.style.position = stickyProp;

      if (newMode === "stickyBottom") {
        if (bottom) {
          this.node.style.bottom = offsetBottom + "px";
        } else {
          this.node.style.top = this.viewPortHeight - this.nodeHeight - offsetBottom + "px";
        }
      } else {
        // stickyTop
        if (bottom) {
          this.node.style.bottom = this.viewPortHeight - this.nodeHeight - offsetBottom + "px";
        } else {
          this.node.style.top = offsetTop + "px";
        }
      }
    }

    this.offset = this.getCurrentOffset();
  };

  _proto.initial = function initial() {
    var bottom = this.props.bottom;

    if (bottom) {
      if (this.mode !== "stickyBottom") this.changeMode("stickyBottom");
    } else {
      if (this.mode !== "stickyTop") this.changeMode("stickyTop");
    }
  };

  _proto.changeToStickyBottomIfBoxTooLow = function changeToStickyBottomIfBoxTooLow(scrollY) {
    var offsetBottom = this.props.offsetBottom;

    if (scrollY + this.scrollPaneOffset + this.viewPortHeight >= this.naturalTop + this.nodeHeight + this.offset + offsetBottom) {
      this.changeMode("stickyBottom");
    }
  };

  _proto.render = function render() {
    var _this$props5 = this.props,
        children = _this$props5.children,
        className = _this$props5.className,
        style = _this$props5.style;
    return react.createElement("div", {
      className: className,
      style: style,
      ref: this.registerContainerRef
    }, children);
  };

  return StickyBox;
}(react.Component);


StickyBox.defaultProps = {
  onChangeMode: function onChangeMode() {},
  offsetTop: 0,
  offsetBottom: 0
};
 false ? 0 : void 0;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [601,2777,1033,7817,9774,2888,179], function() { return __webpack_exec__(27646); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);